module.exports = __webpack_public_path__ + "static/img/img-08.3bf85ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-08.jpg
// module id = 91
// module chunks = 0